export default __webpack_public_path__ + "static/media/Background_00175.7fad7276.png";